import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import {
  Box,
  Typography,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from '@mui/material'
import { PowerSettingsNew, Settings } from '@mui/icons-material'
import { ApplicationState } from '@/state/root.models'

import logoutThunk from '@/state/auth/thunk/logout.thunks'
import AvatarComponent from '@/views/components/avatar-profile'
import useDrawer from '@/hooks/ui/use-drawer.hook'

import { DrawersEnum } from '@/enums/ui/drawer.enum'
import { useAppDispatch } from '@/state'
import useStyles from './style'

import UiFeedbackComponent from './ui-feedback/index.component'

const TopBarDropdownComponent = () => {
  const { t } = useTranslation()

  const { classes } = useStyles()

  const dispatch = useAppDispatch()

  const logout = () => dispatch(logoutThunk())

  const { loggedUser } = useSelector(({ auth }: ApplicationState) => auth)

  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // Edit Profile

  const { handleToggleDrawer } = useDrawer()

  const handleOpenEditProfile = () => {
    handleClose()
    handleToggleDrawer({ open: true, id: DrawersEnum.DRAWER_EDIT_PROFILE })
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        className={classes.barProfile}
        onClick={handleClick}
      >
        <AvatarComponent
          firstName={loggedUser.firstName}
          lastName={loggedUser.lastName}
        />
      </Box>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          style: {
            minWidth: 225,
          },
        }}
        sx={{ marginTop: '17px' }}
      >
        <Box px={2} py={1} className={classes.box}>
          <Typography variant="body2" className="capitalize fontWeight-700">
            {`${loggedUser.firstName} ${loggedUser.lastName}`.toLowerCase()}
          </Typography>
          <Typography variant="caption" component="p" gutterBottom>
            {loggedUser.email}
          </Typography>
        </Box>
        <Divider light sx={{ margin: '5px 5px 15px !important' }} />
        <MenuItem
          className={classes.editProfile}
          onClick={handleOpenEditProfile}
        >
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <ListItemText primary={t('sidebar.editProfile')} />
        </MenuItem>

        <MenuItem onClick={logout} className={classes.logoutLink}>
          <ListItemIcon>
            <PowerSettingsNew />
          </ListItemIcon>
          <ListItemText primary={t('sidebar.logout')} />
        </MenuItem>
      </Menu>
      <UiFeedbackComponent />
    </>
  )
}

export default TopBarDropdownComponent
